import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useLocation } from 'react-router';
import queryparse from 'tricks/string/queryparse';
import config from 'utils/config';
import { checkIsAsset } from 'types/content/utils';
import { HorizontalCard } from 'components/ContentCards';
import Stack from 'components/Stack';
import { useCardController } from 'components/ContentCards/controllers';
import Section from './Section';
import useOpenSection from './useOpenSection';
function ControlledHorizontalCardWithLink(_ref) {
  var data = _ref.data,
    onWebAssetClick = _ref.onWebAssetClick;
  var content = data.contentItem;
  var isAsset = checkIsAsset(content);
  var contentItem = useCardController(_objectSpread(_objectSpread({}, data), {}, {
    onWebAssetClick: onWebAssetClick ? function () {
      return onWebAssetClick({
        type: isAsset ? content.type : undefined,
        markAsDoneMode: isAsset ? content.markAsDoneMode : undefined,
        userContentStatus: content.userContentStatus,
        contentId: content.id
      });
    } : undefined
  }));
  return /*#__PURE__*/React.createElement(HorizontalCard, contentItem);
}
function PlaylistContentTree(_ref2) {
  var parentPlaylist = _ref2.parentPlaylist,
    playlistContent = _ref2.playlistContent,
    isEditablePlaylist = _ref2.isEditablePlaylist,
    nextContentItemId = _ref2.nextContentItemId,
    onWebAssetClick = _ref2.onWebAssetClick,
    _ref2$isPreviewMode = _ref2.isPreviewMode,
    isPreviewMode = _ref2$isPreviewMode === void 0 ? false : _ref2$isPreviewMode;
  var location = useLocation();
  var _queryparse = queryparse(location.search),
    asset = _queryparse.asset;
  var linkedAssetId = asset ? Number(asset) : null; // the id of an asset when the user is linked to it

  var _useOpenSection = useOpenSection({
      isPreviewMode: isPreviewMode,
      defaultSectionState: 'open',
      playlistContent: playlistContent,
      linkedAssetId: linkedAssetId
    }),
    getIsOpen = _useOpenSection.getIsOpen,
    toggleIsOpen = _useOpenSection.toggleIsOpen;
  function renderTree(items) {
    return /*#__PURE__*/React.createElement(Stack, {
      spacing: "l",
      as: config.playlistNumbering ? 'ordered-list' : 'list'
    }, items.map(function (item) {
      if (item.type === 'section') {
        return /*#__PURE__*/React.createElement(Section, {
          key: item.id,
          section: item,
          isPreviewMode: isPreviewMode,
          hasPlaylistNumbering: !!parentPlaylist.hasPlaylistNumbering,
          isSectionOpen: getIsOpen(item.id),
          onToggleOpen: function onToggleOpen() {
            return toggleIsOpen(item.id);
          }
        }, item.children.length ? renderTree(item.children) : null);
      } else {
        var pillKey;
        if (item.goal) {
          pillKey = 'goal';
        } else if (nextContentItemId === item.id) {
          pillKey = 'next';
        }
        var contentItemData = {
          contentItem: _objectSpread(_objectSpread({}, item), {}, {
            isDisabled: isPreviewMode // disable the card in preview mode
          }),
          priorityPillType: pillKey,
          collectionId: parentPlaylist.id,
          playlist: parentPlaylist,
          isEditablePlaylist: isEditablePlaylist,
          canSaveForLater: false,
          canEditPlaylist: true
        };
        return /*#__PURE__*/React.createElement(ControlledHorizontalCardWithLink, {
          key: item.id,
          data: contentItemData,
          onWebAssetClick: onWebAssetClick
        });
      }
    }));
  }
  return renderTree(playlistContent);
}
export default PlaylistContentTree;